import {
  GET_HISTORY_LIST_ACCOUNTANT,
  GET_HISTORY_LIST_ACCOUNTANT_SUCCESS,
  GET_HISTORY_LIST_ACCOUNTANT_FAIL,
} from "./actionTypes";

export const getActivitylogAccountant = id => {
  console.log("ID passed to getActivityLogRounds:", id); // Log both id and type
  return {
    type: GET_HISTORY_LIST_ACCOUNTANT,
    payload: { id }, // Pass both id and type as payload
  };
};

export const getActivitylogAccountantSuccess = activitylogAccountant => {
  console.log("[Action] Success payload:", activitylogAccountant); // Logs API response
  return {
    type: GET_HISTORY_LIST_ACCOUNTANT_SUCCESS,
    payload: activitylogAccountant,
  };
};

export const getActivitylogAccountantFail = error => {
  console.error("[Action] Fail payload:", error); // Logs API error
  return {
    type: GET_HISTORY_LIST_ACCOUNTANT_FAIL,
    payload: error,
  };
};
